module.exports = "pegasus_template/assets/blocks/column-2-theme4.png";